import DiseaseEncyclopediaModel from '@/entities/disease-encyclopedia/model/diseaseEncyclopedia';
import { GetPopularDiseaseEncyclopediasQuery } from '@/types/bff/gql-schema';
import { QueryClient } from '@tanstack/react-query';
import { useGetPopularDiseaseEncyclopediasQuery } from './disease-encyclopedia.gql.impl';

const parseDiseaseEncyclopedia = (data: GetPopularDiseaseEncyclopediasQuery): DiseaseEncyclopediaModel[] => {
  if (data) {
    return data.popularDiseaseEncyclopedias.map((diseaseEncyclopedia) => {
      return new DiseaseEncyclopediaModel({
        publicId: diseaseEncyclopedia.publicId,
        title: diseaseEncyclopedia.title,
        titleImageUrl: diseaseEncyclopedia.titleImageUrl ?? undefined,
        content: diseaseEncyclopedia.content,
      });
    });
  }
  return [] as DiseaseEncyclopediaModel[];
};

interface GetPopularDiseaseEncyclopedias {
  popularDiseaseEncyclopedia: Array<DiseaseEncyclopediaModel> | undefined;
  isPopularDiseaseEncyclopediaLoading: boolean;
}

const DISEASE_ENCYCLOPEDIA_SIZE = 6;

const useGetPopularDiseaseEncyclopedias = (): GetPopularDiseaseEncyclopedias => {
  const { data: popularDiseaseEncyclopedia, isLoading: isPopularDiseaseEncyclopediaLoading } =
    useGetPopularDiseaseEncyclopediasQuery(
      {
        limit: DISEASE_ENCYCLOPEDIA_SIZE,
      },
      {
        select: parseDiseaseEncyclopedia,
      }
    );

  return {
    popularDiseaseEncyclopedia,
    isPopularDiseaseEncyclopediaLoading,
  };
};

export default useGetPopularDiseaseEncyclopedias;

useGetPopularDiseaseEncyclopedias.prefetchQuery = (queryClient: QueryClient) => {
  return queryClient.prefetchQuery(
    useGetPopularDiseaseEncyclopediasQuery.getKey({ limit: DISEASE_ENCYCLOPEDIA_SIZE }),
    useGetPopularDiseaseEncyclopediasQuery.fetcher({ limit: DISEASE_ENCYCLOPEDIA_SIZE })
  );
};
